var CalendarBase = require('./CalendarBase');

/**
 * The CalendarDate class represents a date/datetime/time data type.
 * It handles the formatting and accepts several options like
 * calendar, a custom format string and a subtype.
 *
 * @param {Object} [oConfig] A configuration object that is used to specify the formatting
 * @param {string} [oConfig.utc] Specifies if the CalendarDate is exported in UTC
 * @constructor
 */
function CalendarDate(oConfig) {
	CalendarBase.call(this, oConfig);

	this.utc = true;
}

CalendarDate.prototype = Object.create(CalendarBase.prototype);
CalendarDate.prototype.constructor = CalendarDate;


/**
 * Returns the default NumberFormat for the specific type.
 *
 * @returns {string} NumberFormat template for type Date
 * @private
 */
CalendarDate.prototype.getDefaultFormat = function() {
	return Object.getPrototypeOf(CalendarDate.prototype).getDefaultFormat.call(this)
		|| CalendarBase.BUILTIN[14];
};

module.exports = CalendarDate;